<div class="DetalleBox">
  <div class="tit-DetalleBox">{{ 'DETALLE_DE_VENTA' | translate }}</div>
  <div class="cols">
    <div class="col-left">
      <dl>
        <dt>{{ 'TIPO_DE_OPERACION' | translate }}:</dt>
        <dd>{{ albaran.TipoOperacion | tipoOperacion }}</dd>
        <ng-container *ngIf="albaran.Localizador">
          <dt>{{ 'LOCALIZADOR' | translate }}:</dt>
          <dd>{{ albaran.Localizador }}</dd>
        </ng-container>
        <dt>{{ 'JUSTIFICANTE_No_ALBARAN' | translate }}:</dt>
        <dd>{{ albaran.NumAlbaran }}</dd>
        <dt>{{ 'JUSTIFICANTE_IDENTIFICADOR' | translate }}:</dt>
        <dd>{{ albaran.NumVenta }}</dd>
        <ng-container *ngIf="albaran.OrigenNumVenta">
          <dt>{{ 'N_VENTA_ORIGEN' | translate }}:</dt>
          <dd>{{ albaran.OrigenNumVenta }}</dd>
        </ng-container>
        <dt>{{ 'JUSTIFICANTE_TPV' | translate }}:</dt>
        <dd>{{ albaran.TPVId }}-{{ albaran.TPVNombre }}</dd>
        <ng-container *ngIf="hayCodigoPromocional">
          <dt>{{ 'VALE_PROMOCIONAL' | translate }}:</dt>
          <dd>{{ codigoPromocional }}</dd>
        </ng-container>
        <ng-container *ngIf = "albaran.CodigoClienteId && albaran.CodigoClienteId !=='0'">
          <dt>{{ 'CLIENTE' | translate }}:</dt>
          <dd >{{ albaran.CodigoClienteId}} - {{albaran.NombreCliente}} </dd>
        </ng-container>
        <ng-container *ngIf = "formatearPrecio(albaran.Descuento) > 0 || formatearPrecio(albaran.Descuento) < 0">
          <dt> {{ 'TOTALDESCUENTO' }}:</dt>
          <dd>{{ albaran.Descuento }}</dd>
        </ng-container>
        <ng-container
          *ngIf="
            (albaran.TieneDevoluciones === '0' && albaran.EsDevolucion === 'False') ||
            (albaran.TieneDevoluciones !== '2' && albaran.EsDevolucion === 'False') ||
            albaran.TipoOperacion === '00' ||
            albaran.EsDevolucion === 'True'
          "
        >
          <dt>{{ 'FORMA_PAGO' | translate }}:</dt>
          <dd *ngIf="albaran.AlbaranFOPs.length < 2">
            {{
              getFormaPagoFopLabel(albaran.AlbaranFOPs[0]) ||
                (albaran.FOP === 'CC' && isPagoWaylet()
                  ? ('WAYLET' | translate)
                  : (albaran.FOP | formaPago))
            }}
          </dd>
          <dd *ngIf="albaran.AlbaranFOPs.length > 1">{{ 'MULTIPLE' | translate }}</dd>
          <dt *ngIf="albaran.AlbaranFOPs.length !== 0">{{ 'JUSTIFICANTE_IMPORTE' | translate }}:</dt>
          <dd>
            <table class="fop-table">
              <ng-container *ngFor="let fop of albaran.AlbaranFOPs">
                <ng-container *ngIf="fop.Importe == '0' && albaran.AlbaranFOPs.length == 1">
                  <tr>
                    <td></td>
                    <td>{{ fop.Importe | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }}</td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="fop.Importe !== '0'">
                  
                  <!-- <tr>
                    <td>{{ fop.FOP | formaPago }}</td>
                    <td>{{ fop.Importe | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha  : divisaSimbSeparacionMiles }}</td>
                  </tr> -->
                  <ng-container [ngSwitch]="fop.FOP">
                    <ng-container *ngSwitchCase="'CB'">
                      <tr>
                        <td>{{ fop.FOP | formaPago }}</td>
                        <td>{{ fop.Importe | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha  : divisaSimbSeparacionMiles }}</td>
                      </tr>
                      <ng-container *ngIf="fop.Cheques && fop.Cheques.length">
                        <tr class="cheques-bancaria" *ngFor="let cheque of fop.Cheques">
                          <td>
                            <span>{{ cheque.NumeroCheque }}</span>
                            <span>{{ cheque.NombreBanco }}</span>
                          </td>
                          <td>{{ cheque.Importe | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha  : divisaSimbSeparacionMiles }}</td>
                        </tr>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="'CV'">
                      <tr>
                        <td>{{ fop.FOP | formaPago }}</td>
                        <td>{{ fop.Importe | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha  : divisaSimbSeparacionMiles }}</td>
                      </tr>
                      <ng-container *ngIf="fop.CVaccance && fop.CVaccance.length">
                        <tr class="cheques-vaccance">
                          <td *ngFor="let vaccance of fop.CVaccance">
                            <span>{{ vaccance.ImporteUnitario | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha  : divisaSimbSeparacionMiles }}</span>
                            <span>{{ vaccance.Cantidad }}</span>
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="'SP'">
                      <ng-container *ngIf="fop.OperacionesSINPE && fop.OperacionesSINPE.length">
                        <thead class="sinpe-header" style="font-weight: bold;">
                          <tr>
                            <td colspan="3" style="text-align: left;">{{ 'SINPE' | translate }}:</td>
                          </tr>
                        </thead>
                        <tr
                          class="sinpe-row"
                          *ngFor="let sinpe of fop.OperacionesSINPE"
                          style="align-items: center; gap: 1rem;"
                        >
                          <td style="white-space: nowrap;">
                            {{ sinpe.Importe | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }}
                          </td>
                          <td style="white-space: nowrap;">
                            {{ sinpe.CodReferencia }}
                          </td>
                          <td *ngIf="sinpe.Estado === '0'">
                            <button
                              (click)="vincularPago(sinpe.CodReferencia, sinpe)"
                              class="btn btn-primary"
                              [disabled]="sinpe.VinculacionExitosa"
                            >
                              {{ sinpe.VinculacionExitosa ? ('VINCULADO' | translate) : ('VINCULAR' | translate) }}
                            </button>
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchDefault [ngTemplateOutlet]="otrasFop" [ngTemplateOutletContext]="{$implicit: fop}">
                    </ng-container>
                 </ng-container>
                </ng-container>
              </ng-container>
            </table>
          </dd>

          <ng-template #otrasFop let-fop>
            <tr>
              <td>
                {{
                  getFormaPagoFopLabel(fop) || (fop.FOP | formaPago)
                }}
              </td>
              <td>{{ fop.Importe | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha  : divisaSimbSeparacionMiles }}</td>
            </tr>
          </ng-template>

          <ng-container *ngIf="albaran.FOP === 'CA'">
            <dt>{{ 'RECIBIDO' | translate }}:</dt>
            <dd>{{ albaran.CambioRecibido | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles}} </dd>
            <dt>{{ 'CAMBIO' | translate }}:</dt>
            <dd>{{ albaran.CambioDevuelto | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles}} </dd>
          </ng-container>
          <dt>{{ 'IMPRESSIÓ' | translate }}:</dt>
          <dd>{{ albaran.TipoImpresion | tipoImpresion }}</dd>
        </ng-container>      
      </dl>
    </div>
    <div class="col-right">
      <div class="resultado">
        <div class="data">
          <span class="small"
            >{{ 'JUSTIFICANTE_FECHA_VISITA' | translate }}:
            {{ albaran.FechaHoraEntrada | fecha: 'YYYY/MM/DD HH:mm:ss':'es-ES' }}</span
          >
        </div>
      </div>
      <div class="tit-historico">{{ 'HISTORICO_VENTA' | translate }}:</div>
      <perfect-scrollbar class="scroll-historico">
        <ul>
          <li *ngFor="let registro of albaran.AlbaranHistorial">
            {{ registro.Fecha + ' ' + registro.Hora | fecha: 'YYYY/MM/DD HH:mm:ss':'es-ES' }}
            - {{ registro.TipoAccion | tipoAccion }} {{getNumAlbaran(registro)}}
          </li>
        </ul>
      </perfect-scrollbar>
    </div>
  </div>

  <div class="cols">
    <div class="col-factura">
      <dl>        
        <ng-container *ngIf="!(albaran.Facturado === 'False' || albaran.Facturado === '0')">
          <dt class="m-factura">{{ 'FACTURA' | translate }}:</dt>
          <div class="datos-factura">
            <span>{{ albaran.SerieFactura }}{{ albaran.NumFacturaId }}</span>
            <span>{{ albaran.FacturaFecha }}</span>
            <a class="print-factura" title="Imprimir" (click)="imprimir(albaran)">
              <img class="img-factura" src="assets/img/icon-print.svg" alt="icono Imprimir" />
            </a>

            <div *ngIf="showEnvioMail"
            [ngClass]="{ 'checkboxStyled': true, 'checked': true }">
              <div class="center">
                <label class="label" for="myCheckboxStyledGes">
                  <input
                    class="label__checkbox w-100"
                    type="checkbox"
                    [(ngModel)]="enviarMail"
                    id="myCheckboxStyledGes"
                  />
                  <span class="label__check">
                    <img
                      class="svg"
                      src="assets/img/checkbox-mark.svg"
                      alt="icono checkbox"
                    />
                  </span>
                </label>
              </div>
              <label class="label__text" for="myCheckboxStyledGes">{{
                'OPCIONES_PAGO_ENVIO_MAIL' | translate
              }}</label>
            </div>

          </div>          
        </ng-container>
      </dl>
    </div>   
  </div>

</div>


